/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Meta_TitleInputs */

const en_wc_vs_meta_title = /** @type {(inputs: Wc_Vs_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft vs Microsoft Word: Differences, Pros and Cons (2026)`)
};

/**
* | output |
* | --- |
* | "WordCraft vs Microsoft Word: Differences, Pros and Cons (2026)" |
*
* @param {Wc_Vs_Meta_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_meta_title = /** @type {((inputs?: Wc_Vs_Meta_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Meta_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_meta_title(inputs)
});
export { wc_vs_meta_title as "wc.vs.meta_title" }